import apiClient from "../apiClient";

export const getAllBadgesAPI = async () => {
  try {
    const responseBadges = await apiClient.get("badges/badge-actives");
    return responseBadges?.data?.data ?? [];
  } catch (error) {
    throw error;
  }
};

export const createBadgeAPI = async (badgeData) => {
  try {
    const response = await apiClient.post("badges/create-badge", badgeData);
    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const updateBadgeAPI = async (badgeData, badgeId) => {
  try {
    const response = await apiClient.put(
      `badges/modify-bagde/${badgeId}`,
      badgeData
    );
    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const deleteBadgeAPI = async (badgeId) => {
  try {
    const response = await apiClient.delete(`badges/delete-badge/${badgeId}`);
    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};
